import React, { PureComponent } from 'react';
import { NormalizedSeries } from 'types';
import { DragSource, DragSourceSpec, DragLayer } from 'react-dnd';
import styles from './chart.scss';
import { CHART_TARGET_TYPE } from './utils';

interface ChartSeriesLabelProps {
  series: NormalizedSeries;
  disabled: boolean;
}

const dragSource: DragSourceSpec<ChartSeriesLabelProps> = {
  beginDrag(props) {
    const { series } = props;
    return {
      name: series.name || series.id,
      color: series.color,
      id: props.series.id
    };
  },
  canDrag() {
    return true;
  }
};
@DragSource(CHART_TARGET_TYPE, dragSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  dragging: monitor.isDragging()
}))
class ChartSeriesLabel extends PureComponent<ChartSeriesLabelProps> {
  render() {
    const { series, disabled, dragging, connectDragSource } = this.props;

    let cl = styles.series;
    if (dragging) cl += ' ' + styles.dragging;
    return connectDragSource(
      <div className={cl} style={{ color: !disabled && series.color }}>
        <b /> {series.name || series.id}
      </div>,
      { dropEffect: 'move' }
    );
  }
}

export default ChartSeriesLabel;
